import type { SocialProfile } from './types';

/** Advance through the cached pool only between visits, not after a follow. */
export function selectSuggestedCreators(profiles: readonly SocialProfile[], viewerId: string | undefined, cursor = 0) {
  const ids: string[] = [];
  if (!profiles.length) return { ids, nextCursor: 0 };
  const start = Number.isSafeInteger(cursor) && cursor >= 0 ? cursor % profiles.length : 0;
  let scanned = 0;
  while (scanned < profiles.length && ids.length < 3) {
    const person = profiles[(start + scanned++) % profiles.length];
    if (person.id !== viewerId && !person.blocked && person.relationship === 'none' && !ids.includes(person.id)) ids.push(person.id);
  }
  return { ids, nextCursor: (start + scanned) % profiles.length };
}
